import React from "react";
import { cn } from "../../utils/cn";

export const Badge = ({
  text,
  color,
}: {
  text: string;
  color?: "green" | "red" | "gray" | "gold" | "yellow" | "blue";
}) => (
  <span
    className={cn(
      "text-xs font-medium px-2 py-1 rounded-full",
      color === "green"
        ? "bg-green-100 text-green-700"
        : color === "red"
        ? "bg-red-100 text-red-700"
        : color === "yellow"
        ? "bg-yellow-100 text-yellow-700"
        : color === "blue"
        ? "bg-blue-100 text-blue-700"
        : "bg-gray-100 text-gray-700"
    )}
  >
    {text}
  </span>
);
